import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest, of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { LocationSelectors } from '../locations/locations.store';
import { LocationsJobsHttpClient } from './locations-jobs.http-client';
import { LocationJobsActions } from './locations-jobs.store';

@Injectable({ providedIn: 'root' })
export class LocationsJobsEffects {
  public fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationJobsActions.fetchOne),
      switchMap(({ payload: { id } }) =>
        this.http.fetch(id).pipe(
          switchMap(response =>
            response.offers.length
              ? combineLatest(
                  response.offers.map(job =>
                    this.store
                      .select(LocationSelectors.byIds(job.locationIds))
                      .pipe(map(locations => ({ ...job, locations }))),
                  ),
                )
              : of([]),
          ),
          map(jobs =>
            LocationJobsActions.fetchOneSuccess({
              payload: { data: { id, jobs } },
            }),
          ),
        ),
      ),
      catchError(error => of(LocationJobsActions.fetchOneFailed({ payload: error }))),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private http: LocationsJobsHttpClient,
  ) {}
}
